<div class="notification-list">
  <ng-container *ngIf="notifications$ | async as notifications">
    <div *ngIf="notifications.length === 0" class="empty-state text-muted p-3">
      No new notifications
    </div>

    <ng-container *ngFor="let n of notifications; let last = last">
      <div
        class="notification-item d-flex align-items-start p-3"
        [class.unread]="!n.is_read"
        [class.dismissed]="n.is_dismiss"
        (click)="clickNotification(n)"
      >
        <div class="flex-grow-1 overflow-hidden">
          <div class="notification-title fw-semibold text-truncate">{{ n.title }}</div>
          <div class="notification-text text-muted small text-truncate">{{ n.text }}</div>
          <div class="notification-time text-muted" style="font-size: 0.7rem">
            {{ n.notification_created_at | date: 'dd MMM, HH:mm' }}
          </div>
        </div>
        <button
          *ngIf="!n.is_dismiss"
          mat-icon-button
          class="dismiss-btn ms-1 flex-shrink-0"
          (click)="dismiss($event, n)"
          aria-label="Dismiss notification"
        >
          <mat-icon style="font-size: 16px; width: 16px; height: 16px">close</mat-icon>
        </button>
      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </ng-container>

  <mat-divider></mat-divider>
  <div class="d-flex justify-content-between align-items-center py-1 px-2">
    <button mat-button color="primary" (click)="toggleShowAll($event)">
      {{ (showAll$ | async) ? 'Nascondi vecchie' : 'Mostra vecchie' }}
    </button>
    <a mat-button [routerLink]="['/', 'notifications', 'history']" (click)="$event.stopPropagation()">
      Storico completo
    </a>
  </div>
</div>
